import React, { useState } from 'react';
import { SmartphoneIcon, TabletIcon, MonitorIcon } from 'lucide-react';
interface EmailPreviewProps {
  subject: string;
  html: string;
}
export function EmailPreview({
  subject,
  html
}: EmailPreviewProps) {
  const [device, setDevice] = useState<'mobile' | 'tablet' | 'desktop'>('desktop');
  const getDeviceWidth = () => {
    switch (device) {
      case 'mobile':
        return '375px';
      case 'tablet':
        return '768px';
      case 'desktop':
        return '100%';
    }
  };
  return <div className="space-y-4" data-id="element-1897">
      <div className="flex items-center justify-between bg-white p-2 rounded-lg border border-gray-200" data-id="element-1898">
        <div className="flex items-center gap-1 bg-gray-100 p-1 rounded-md" data-id="element-1899">
          <button onClick={() => setDevice('mobile')} className={`p-1.5 rounded transition-colors ${device === 'mobile' ? 'bg-white shadow-sm text-blue-600' : 'text-gray-500 hover:text-gray-700'}`} title="Mobile view (375px)" data-id="element-1900">
            <SmartphoneIcon className="h-4 w-4" data-id="element-1901" />
          </button>
          <button onClick={() => setDevice('tablet')} className={`p-1.5 rounded transition-colors ${device === 'tablet' ? 'bg-white shadow-sm text-blue-600' : 'text-gray-500 hover:text-gray-700'}`} title="Tablet view (768px)" data-id="element-1902">
            <TabletIcon className="h-4 w-4" data-id="element-1903" />
          </button>
          <button onClick={() => setDevice('desktop')} className={`p-1.5 rounded transition-colors ${device === 'desktop' ? 'bg-white shadow-sm text-blue-600' : 'text-gray-500 hover:text-gray-700'}`} title="Desktop view (100%)" data-id="element-1904">
            <MonitorIcon className="h-4 w-4" data-id="element-1905" />
          </button>
        </div>
      </div>

      <div className="bg-gray-50 p-4 rounded-md border border-gray-200" data-id="element-1906">
        <span className="text-sm font-medium text-gray-500" data-id="element-1907">Subject:</span>
        <span className="ml-2 text-sm text-gray-900 font-medium" data-id="element-1908">
          {subject}
        </span>
      </div>

      <div className="w-full bg-gray-100 rounded border border-gray-200 overflow-hidden flex justify-center py-4 min-h-[500px]" data-id="element-1909">
        <div className="bg-white shadow-sm transition-all duration-300 ease-in-out h-full overflow-y-auto" style={{
        width: getDeviceWidth(),
        minHeight: '500px'
      }} data-id="element-1910">
          <div className="bg-gray-100 px-4 py-2 border-b border-gray-200 text-xs text-gray-500 uppercase tracking-wide" data-id="element-1911">
            Email Body Preview
          </div>
          <div className="p-8 bg-white min-h-[400px] prose max-w-none" dangerouslySetInnerHTML={{
          __html: html
        }} data-id="element-1912" />
        </div>
      </div>
    </div>;
}